import styled from 'styled-components'

export const Card = styled.article`
  width: 18rem;
  height: 14rem;

  background: #ffffff;
  //box-shadow: 4px 4px 18px -5px rgba(218, 221, 232, 0.8);
  border-radius: 25px;

  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;

  position: relative;
  text-align: left;

  overflow-y: auto;
`

export const Text1 = styled.p`
  margin-top: 1rem;
  color: black;

  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: center;
`
export const Text2 = styled.p`
  margin-top: 1rem;
  color: #7d7d7d;

  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: center;
`
export const Link = styled.a`
  margin-top: 1rem;

  font-family: 'Inter';
  font-size: 14px;
  max-width: 100%;
  padding: 11px 13px;
  color: rgb(253, 249, 243);
  font-weight: 600;
  text-transform: uppercase;
  text-decoration: none;
  background-color: #2d60ff;
  border: none;
  border-radius: 10px;
  outline: 0;
  cursor: pointer;
  margin-top: 0.6rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.1);
  :hover {
    opacity: 0.8;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.1);
  }
`
